import React from 'react';
import { Shield, AlertCircle, Clock, MapPin } from 'lucide-react';
const ServiceCoverage = () => {
  return <div className="min-h-screen bg-white" data-id="element-652">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-653">
        <div className="container mx-auto px-4" data-id="element-654">
          <div className="flex flex-col md:flex-row items-center" data-id="element-655">
            <div className="md:w-2/3" data-id="element-656">
              <h1 className="text-3xl font-bold mb-4" data-id="element-657">Service Details</h1>
              <p className="text-lg" data-id="element-658">
                Learn about our service packages, engineer callout procedures,
                service areas, and what is included in our professional repair
                and maintenance work.
              </p>
            </div>
            <div className="md:w-1/3 flex justify-center mt-8 md:mt-0" data-id="element-659">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i3r48ZKNYAoPu74gxfDsXC/Maplewood_staff_fixing_TV.jpg" alt="Maplewood Care Engineer Fixing TV" className="max-w-full md:max-w-xs object-cover rounded-md shadow-md" data-id="element-660" />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-661">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-662">
          <div data-id="element-663">
            <h2 className="text-2xl font-bold text-mwc-burgundy mb-6" data-id="element-664">
              Service Package Activation
            </h2>
            <div className="space-y-6" data-id="element-665">
              <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-666">
                <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-667">
                  When does my service package start?
                </h3>
                <p className="text-gray-700" data-id="element-668">
                  Your prepaid service package activates immediately once
                  payment is confirmed. You will receive an email confirmation
                  within minutes.
                </p>
              </div>
              <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-669">
                <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-670">
                  Do I need to schedule anything to activate the package?
                </h3>
                <p className="text-gray-700" data-id="element-671">
                  No. Your service package begins automatically and runs for 12
                  months from the purchase date.
                </p>
              </div>
              <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-672">
                <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-673">
                  When does the service package expire?
                </h3>
                <p className="text-gray-700" data-id="element-674">
                  Your prepaid service package ends exactly 12 months later at
                  23:59 on the final day unless renewed.
                </p>
              </div>
              <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-675">
                <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-676">
                  How do I book a repair visit?
                </h3>
                <p className="text-gray-700" data-id="element-677">Contact us by:</p>
                <p className="text-gray-700 mt-2" data-id="element-678">
                  📞 0800 055 4969
                  <br data-id="element-679" />
                  📧 support@maplewood-care.com
                </p>
                <p className="text-gray-700 mt-2" data-id="element-680">
                  One of our team members will arrange your engineer visit,
                  usually within 24–48 hours.
                </p>
              </div>
            </div>
          </div>
          <div data-id="element-681">
            <h2 className="text-2xl font-bold text-mwc-burgundy mb-6" data-id="element-682">
              Service Package Details
            </h2>
            <div className="bg-mwc-lightpink p-6 rounded-lg mb-6" data-id="element-683">
              <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-684">
                What is Included:
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-685">
                <li className="flex items-start" data-id="element-686">
                  <Shield size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-687" />
                  <span data-id="element-688">
                    Unlimited repair callouts and diagnostics for specified
                    appliances during the 12-month service period
                  </span>
                </li>
                <li className="flex items-start" data-id="element-689">
                  <Shield size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-690" />
                  <span data-id="element-691">All labour costs included</span>
                </li>
                <li className="flex items-start" data-id="element-692">
                  <Shield size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-693" />
                  <span data-id="element-694">
                    Replacement parts included (subject to availability)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-695">
                  <Shield size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-696" />
                  <span data-id="element-697">
                    Engineer visits arranged within 24–48 hours of reporting a
                    fault
                  </span>
                </li>
                <li className="flex items-start" data-id="element-698">
                  <Shield size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-699" />
                  <span data-id="element-700">
                    Professional service for mechanical and electrical faults
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-mwc-lightpink p-6 rounded-lg mb-6" data-id="element-701">
              <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-702">
                What is Not Included:
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-703">
                <li className="flex items-start" data-id="element-704">
                  <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-705" />
                  <span data-id="element-706">Cosmetic damage or general wear and tear</span>
                </li>
                <li className="flex items-start" data-id="element-707">
                  <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-708" />
                  <span data-id="element-709">
                    Pre-existing faults before service package activation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-710">
                  <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-711" />
                  <span data-id="element-712">Damage caused by misuse or unauthorised repairs</span>
                </li>
                <li className="flex items-start" data-id="element-713">
                  <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-714" />
                  <span data-id="element-715">
                    Appliances older than 10 years when the service package
                    begins
                  </span>
                </li>
                <li className="flex items-start" data-id="element-716">
                  <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-717" />
                  <span data-id="element-718">Damage from natural disasters, floods, or fire</span>
                </li>
              </ul>
            </div>
            <div className="flex flex-col md:flex-row gap-6" data-id="element-719">
              <div className="bg-mwc-lightpink p-6 rounded-lg flex-1" data-id="element-720">
                <div className="text-mwc-burgundy mb-3" data-id="element-721">
                  <MapPin size={24} data-id="element-722" />
                </div>
                <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-723">
                  Service Area:
                </h3>
                <p className="text-gray-700" data-id="element-724">
                  We currently provide services to mainland UK postcodes only.
                </p>
                <p className="text-gray-700 mt-2" data-id="element-725">
                  Remote areas (e.g. Scottish Highlands) may have longer
                  response times. Please contact us to check service
                  availability in your location.
                </p>
              </div>
              <div className="bg-mwc-lightpink p-6 rounded-lg flex-1" data-id="element-726">
                <div className="text-mwc-burgundy mb-3" data-id="element-727">
                  <Clock size={24} data-id="element-728" />
                </div>
                <h3 className="text-lg font-semibold text-mwc-burgundy mb-3" data-id="element-729">
                  Response Time:
                </h3>
                <p className="text-gray-700" data-id="element-730">
                  We aim to arrange an engineer visit within 24–48 hours,
                  excluding weekends and public holidays.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-red-50 border border-red-100 rounded-lg p-6" data-id="element-731">
          <h2 className="text-xl font-bold text-mwc-burgundy mb-4" data-id="element-732">
            Service Exclusions & Limitations
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-733">
            To maintain fair use and service quality, the following are excluded
            from our prepaid service packages:
          </p>
          <ul className="space-y-2 text-gray-700" data-id="element-734">
            <li className="flex items-start" data-id="element-735">
              <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-736" />
              <span data-id="element-737">
                Damage or faults existing before service package activation
              </span>
            </li>
            <li className="flex items-start" data-id="element-738">
              <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-739" />
              <span data-id="element-740">Damage caused by misuse, neglect, or tampering</span>
            </li>
            <li className="flex items-start" data-id="element-741">
              <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-742" />
              <span data-id="element-743">Repairs unrelated to normal appliance function</span>
            </li>
            <li className="flex items-start" data-id="element-744">
              <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-745" />
              <span data-id="element-746">Misuse of our services or fraudulent requests</span>
            </li>
            <li className="flex items-start" data-id="element-747">
              <AlertCircle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-748" />
              <span data-id="element-749">
                Appliances not used according to manufacturer guidelines
              </span>
            </li>
          </ul>
          <p className="text-gray-700 mt-4 font-semibold" data-id="element-750">
            Important: If any of these apply, your service package may be voided
            with no refund
          </p>
        </div>
      </div>
    </div>;
};
export default ServiceCoverage;